<template>
  <div>
    <mds-button-container>
      <!-- <mds-button
        v-for="(button, i) in buttonDataTypeConfig"
        variation="secondary"
        size="small"
        icon-right="caret-down"
        @click="toggle = !toggle"
        :key="i"
        :id="uniqueId"
        :class="i > 0 ? $style['button-margin'] : ''"
      >
      </mds-button>
      <mds-popover
        :triggered-by="uniqueId"
        v-model="toggle"
        :class="$style['popover-margin']"
        :position="['bottom-right']"
      >
        <mds-list-group>
          <mds-list-group-item
            :key="item"
            v-for="item in button.listItems"
            :text="item.itemText"
            aria-current="true"
            :active="item.isActive"
            @click.native="emitDataTypeChange(button, item, button.filterType)"
          >
          </mds-list-group-item>
        </mds-list-group>
      </mds-popover> -->

      <mds-button
        variation="secondary"
        size="small"
        icon-right="caret-down"
        :key="i"
        v-for="(button, i) in buttonViewTypeConfig"
        :id="uniqueId2"
        :class="i > 0 ? $style['button-margin'] : ''"
        @click="toggle2 = !toggle2"
      >
        {{ button.text }}

        <mds-popover
          :triggered-by="uniqueId2"
          v-model="toggle2"
          :position="['bottom-right']"
        >
          <mds-list-group>
            <mds-list-group-item
              :key="item"
              v-for="item in button.listItems"
              :text="item.itemText"
              aria-current="true"
              :active="item.isActive"
              @click.native="
                toggle2 = false;
                emitViewTypeChange(button, item, button.filterType);
              "
            >
            </mds-list-group-item>
          </mds-list-group>
        </mds-popover>
      </mds-button>
    </mds-button-container>
  </div>
</template>
<script>
import { MdsButton, MdsButtonContainer } from "@mds/button";
import MdsPopover from "@mds/popover";
import { CommonHelper } from "../../helpers";
import { MdsListGroup, MdsListGroupItem } from "@mds/list-group";
export default {
  name: "graph-selection",
  props: {
    buttonDataTypeConfig: {
      type: Array,
    },
    buttonViewTypeConfig: {
      type: Array,
    },
  },
  components: {
    MdsButton,
    MdsPopover,
    MdsListGroup,
    MdsListGroupItem,
    MdsButtonContainer,
  },

  data() {
    return {
      toggle: false,
      toggle1: false,
      toggle2: false,
      uniqueId: CommonHelper.uuidv4(),
      uniqueId2: CommonHelper.uuidv4(),
    };
  },

  computed: {},

  async created() {},
  methods: {
    clcikm() {
      alert("a");
    },
    emitDataTypeChange(button, item, filterType) {
      this.$emit("onSelectDataTypeFilter", button, item, filterType);
    },

    emitViewTypeChange(button, item, filterType) {
      this.$emit("onSelectViewTypeFilter", button, item, filterType);
    },
    closeAllPopover() {
      if (this.buttonDataTypeConfig.length > 0)
        this.buttonDataTypeConfig[0].toggle1 = false;
      if (this.buttonViewTypeConfig.length > 0)
        this.buttonViewTypeConfig[0].toggle2 = false;
    },
  },
};
</script>
<style lang="scss" module>
.button-margin {
  margin-left: $mds-space-2-x;
}

.popover-margin {
  margin-left: 280px;
  margin-top: 50px;
}
.mds-popover {
  z-index: 99999 !important;
}
</style>
